export default __webpack_public_path__ + "static/media/upcoming-collection--collection-3.d022373e.png";